<title>{{ supportPage.htmlTitle }}</title>
<app-banner [banner]="supportPage.banner"></app-banner>
<app-support-page-outage-banner-section [outageBanners]="supportPage.outageBanners"></app-support-page-outage-banner-section>
<div class="container mb-5 mt-3">
  <br />
  <app-section [sections]="supportPage.sections"></app-section>
  <app-support-card [supportCards]="supportPage.supportCards"></app-support-card>
</div>

<div class="subscribeLink">
  <button class="subscribeMe" *ngIf="isUserLoggedIn && !technicalOperationSubscribed"><i class="fa fa-envelope"></i><a href="/profile">Subscribe Notifications</a></button>
  <button class="subscribeMe" *ngIf="!isUserLoggedIn" data-bs-toggle="modal" (click)="openLoginModal()"><i class="fa fa-envelope"></i> Subscribe Notifications</button>
  <button class="subscribeMe-green" *ngIf="isUserLoggedIn && technicalOperationSubscribed"><i class="fa fa-bell"></i><a href="/profile">Subscribed</a></button>
</div>
